import React from "react";
import { DesignTasksPolaris } from "../../components/tasks/DesignTasksPolaris";
import { getPathFromRouter } from "../../helper";

export const DesignTasksPagePolaris = (...props) => {
  const path = getPathFromRouter(props);
  return <DesignTasksPolaris path={path} />;
};
